import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { salaryGradeQuerySchema } from './salary-grade-query-schema';

export const salaryGradeFormSchema = salaryGradeQuerySchema.omit({ name: true, status: true }).extend({
  name: z.string().min(1),
  status: statusFormSchema,
});

export type SalaryGradeFormSchema = z.infer<typeof salaryGradeFormSchema>;
